import { ShaderMaterial, Vector3 } from 'three';
import vert from './shaders/vert.glsl';
import frag from './shaders/frag.glsl';

import emitter from '@/scripts/stage/globals/emitter';


import {

  DEBUG,
  IS_SPECULAR,
  IS_LIGHT_RTN,

} from '@/scripts/stage/constants';

import gui from '@/scripts/stage/globals/gui';

import Shared from '@/scripts/stage/shared/index';

export default class BlobMaterial extends ShaderMaterial {
  constructor() {
    const opts = {
      vertexShader: vert,
      fragmentShader: frag,

      uniforms: {

        shape: {
          value: new Vector3(3.0, 2.0, 1.0),
        },

        timer: {
          value: 0,
        },

        fogNear: {
          value: 0,
        },

        fogFar: {
          value: 50,
        },

        shapeRatio: {
          value: 0,
        },

        organicity: {
          value: 0.0,
        },

        layerPower: {
          value: 0.0,
        },

      },

      side: 2,

      defines: {

      },
    };

    opts.uniforms.fogColor = Shared.fogColor;

    opts.uniforms.screensize = Shared.screensize;

    opts.uniforms.objColor = Shared.objColor;

    opts.uniforms.aspect = Shared.aspect;

    opts.uniforms.hemi_ground = Shared.hemi_ground;

    opts.uniforms.hemi_color_1 = Shared.hemi_color_1;

    opts.uniforms.hemi_color_2 = Shared.hemi_color_2;

    opts.uniforms.hemi_color_3 = Shared.hemi_color_3;


    if (IS_SPECULAR) {
      opts.uniforms.shininess = { value: 2 };
      opts.uniforms.specularity = { value: 2 };
      opts.uniforms.surface = { value: 0.8 };
      opts.defines.SPECULAR = '1';
    }

    if (IS_LIGHT_RTN) {
      opts.defines.LIGHT_RTN = '1';
    }


    super(opts);

    this.addEvents();

    if (DEBUG) {
      gui.add(this.uniforms.shapeRatio, 'value', 0, 1).step(0.001).name('shaperatio').listen();
      gui.add(this.uniforms.fogNear, 'value', 0, 30).step(0.001).name('fogNear').listen();
      gui.add(this.uniforms.fogFar, 'value', 0, 60).step(0.001).name('fogFar').listen();
      gui.add(this.uniforms.organicity, 'value', 0.0, 0.06).step(0.001).name('organicity').listen();
      gui.add(this.uniforms.layerPower, 'value', 0.0, 1).step(0.001).name('layerPower').listen();

      gui.add(this.uniforms.shape.value, 'x', 0.0, 4).step(0.5).name('ShapeA').listen();
      gui.add(this.uniforms.shape.value, 'y', 0.0, 4).step(0.5).name('ShapeN').listen();
      gui.add(this.uniforms.shape.value, 'z', 0.0, 4).step(0.5).name('ShapeM').listen();

      if (IS_SPECULAR) {
        gui.add(this.uniforms.shininess, 'value', 0, 5).step(0.001).name('shininess').listen();
        gui.add(this.uniforms.specularity, 'value', 0, 5).step(0.001).name('specularity').listen();
        gui.add(this.uniforms.surface, 'value', 0, 1).step(0.001).name('surface').listen();
      }
    }
  }


  setOrganicity(val) {
    this.uniforms.organicity.value = val;
  }

  update(delta) {
    this.uniforms.timer.value += delta;
  }


  addEvents() {
    this.updateEvent = this.update.bind(this);

    emitter.on('update', this.updateEvent);
  }
}
